import React from 'react'
import {Link} from 'react-router-dom';

const Footer = () => {
    return (
        <div>

<section className="bg-gradient-primary-to-secondary" id="download">
        <div className="container px-5">
            <h2 className="text-center text-white font-alt mb-4">Disponible para.</h2>
            <div className="d-flex flex-column flex-lg-row align-items-center justify-content-center">
                <a className="me-lg-3 mb-4 mb-lg-0" href="#!"><img className="app-badge" src="assets/img/google-play-badge.svg"
                        alt="..." /></a>
                <a href="#!"><img className="app-badge" src="assets/img/app-store-badge.svg" alt="..." /></a>
            </div>
        </div>
    </section>

    
    <footer className="bg-black text-center py-5">
        <div className="container px-5">
            <div className="text-white-50 small">
                <div className="mb-2">&copy; Todos los derechos son reservados.</div>
                <Link to="/politicas">Terminos y condiciones</Link>
                
            </div>
        </div>
    </footer>


            
        </div>
    )
}

export default Footer
